import { isNil } from 'Utils/common';
import { scrollToAnchor } from 'Utils/view';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('view', [
      'scrollOffsetTop',
    ]),
  },
  watch: {
    '$route.hash'() {
      setTimeout(
        () => scrollToAnchor(this.$route.hash, this.$_scrollByHash_getOffset()),
        this.$_scrollByHash_timeout,
      );
    },
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(
        () => scrollToAnchor(this.$route.hash, this.$_scrollByHash_getOffset()),
        this.$_scrollByHash_timeoutOnMounted,
      );
    }
  },
  methods: {
    $_scrollByHash_getOffset() {
      const mainOffset = isNil(this.$_scrollByHash_offset) ? this.scrollOffsetTop : this.$_scrollByHash_offset;
      return mainOffset + this.$_scrollByHash_offsetAdditional;
    },
  },
  staticData: {
    $_scrollByHash_timeout: 0,
    $_scrollByHash_timeoutOnMounted: 500,
    $_scrollByHash_offset: null,
    $_scrollByHash_offsetAdditional: 0,
  },
};
